<app-header></app-header>
<section class="container-xxl">
    <div class="breadcrumb-area">
        <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}" *ngIf="showBarComponent"></app-plugin-breadcrumb>
    </div>
    <div class="inner-page-sidedetails">
        <div id="section-New"></div>
        <div class="inner-banner-image">
            <div class="image-area">
                <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
            </div>
        </div>
        <div class="details">
            <div class="title d-flex justify-content-between">
           <h2 class="screen-reader">{{'News' | translate}}</h2>
                <a routerLink="/archivenewslist" [attr.title]="language=='English'?'Archive News':'समाचार संग्रहीत करें'" class="btn btn-sm btn-outline-success screen-reader"><i class="bi bi-archive me-2"></i>{{'ArchiveNews' | translate}}</a>
            </div>
            
            <div class="description">
                <div class="news mb-3">
                    <div class="row">
                     
                        <div class="col-lg-12"   >
                            <!-- search section  Start-->
                            <div class="searchpanel notific-frm" *ngIf="issearch == true || isdisplay == true">
                                <form [formGroup]="searchForm" (ngSubmit)="searchNewsList()">
                                <div class="row">
                                    
                                    <div class="col-xl-3 col-md-6 col-sm-6 col-xs-12">
                                        <div class="form-group font-adjust">
                                            <label class="mb-2 mt-2 screen-reader"> <b> {{'Newstitle' | translate}} </b> </label>
                                            <input type="text" autocomplete="off"
                                                class="form-control screen-reader" placeholder="{{'Newstitle' | translate}}" name="title" id="title" formControlName="title">
                                        </div>
                                    </div>
                            


                                    <div class="col-xl-3 col-md-6 col-sm-6 col-xs-12">
                                        <div class="form-group font-adjust">
                                            <label class="mb-2 mt-2 screen-reader"> <b>{{'DateFrom' | translate}}</b></label>
                                            <input type="date" autocomplete="off"
                                                class="form-control screen-reader" placeholder="From Date" name="from_date" id="from_date" formControlName="from_date">
                            
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-md-6 col-sm-6 col-xs-12">
                                        <div class="form-group font-adjust">
                                            <label class="mb-2 mt-2 screen-reader"> <b>{{'DateTo' | translate}}</b> </label>
                                            <input type="date" autocomplete="off"
                                                class="form-control screen-reader" placeholder="To Date" name="to_date" id="to_date" formControlName="to_date">
                            
                                        </div>
                                    </div>
                                      

 
                                    <div class="col-xl-3 col-md-6 col-sm-6 col-xs-12 d-flex align-items-end">
                                        <div class="d-flex align-items-center gap-3 mt-3">
                                            
                                            <!-- <button type="submit" class="btn btn-outline-success" [disabled]="ifdisabled" [innerHTML]="btncontent"> 
                                            </button> -->
                                            <button type="submit" [attr.title]="language=='English'?'Search':'खोजें'" class="btn btn-outline-success screen-reader" [disabled]="ifdisabled"> {{'Search' | translate}}
                                            </button>
                                            <div *ngIf="RefreshBtn">
                                                <button type="button" [attr.title]="language=='English'?'Refresh':'रीफ़्रेश करें'" class="btn btn-outline-secondary py-0-2 screen-reader" (click)="RefreshPage()"> 
                                                    <i class="bi bi-arrow-repeat fs-5" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            </div>
                               <!-- search section  End-->
                            <div class="info-box" >
                                <div class="row" *ngIf="mediaResponse && mediaResponse.length > 0; else noDataTemplate">
                                    <div class="col-sm-12 col-md-6" *ngFor="let item of mediaResponse | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords}">
                                        <div class="d-flex gap-3 mb-3 brd-bottom pb-3 position-relative mx-md-4">
                                            <div class="info-detail-box d-flex flex-column  font-adjust">
                                                <span class="screen-reader">{{htmldecode(language == 'English' ? item.title: item.titleInHindi)}}.</span>
                                                <div class="text-grey mt-2">
                                                    <span class="me-2"><i class="icon-fci-calendar"></i></span>
                                                    <span class="info-date screen-reader">{{item.publishDate|date}}</span>
                                                </div>
                                                <div class="mt-2">
                                                    <a class="screen-reader" (click)="viewDetails(item.id)" [attr.title]="language=='English'?'View Details':'विवरण देखें'">
                                                        <i class="bi bi-arrow-right"></i>
                                                        {{'ViewDetails' | translate}}
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="info-image-box" *ngIf="item.uploadImage">
                                                <img [src]="this.imageUrl + item.uploadImage" class="img-fluid" alt="FCI-News-Image">
                                               
                                            </div>
                                        </div>
                                    </div>
                                    <div class="my-4">
                                        <pagination-controls class="text-center screen-reader" (pageChange)="pageChanged($event)" *ngIf="totalRecords > 10"></pagination-controls>
                                    </div>
                                </div>
                               
                                  <ng-template #noDataTemplate>
                       
                                    <p class="screen-reader font-adjust" [style.text-align]="'center'"><b>
                                        {{ "Nodataavailable" | translate }}
                                    </b></p>
            
                                  </ng-template>
                            </div>
                          
                        </div>
                        

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<app-clients></app-clients>
<app-footer></app-footer>